module.exports = __webpack_public_path__ + "static/media/einvoice-completed.e8507909.svg";